<div class="col-12" id="account">
    <div class="col-12">
        <h2 class="page-title" tabindex="0">{{'account.change-plan-prorate' | translate}}</h2>
        <ngx-spinner bdColor="rgba(51,51,51,0.55)"
            size="medium"
            color="#fff"
            type="line-spin-clockwise-fade"
            [fullScreen]="false">
            <p class="loading">{{ 'general.loading' | translate }}...</p>
        </ngx-spinner>
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
            </ng-container>
        </xng-breadcrumb>
        <div *ngIf="cart!=null">
            <form [formGroup]="upgradeSubscriptionForm" class="w-100" name="form" (ngSubmit)="upgradeSubscription()">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2">
                        <div class="card border-top">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-2 d-none d-sm-block">
                                        <img src="assets/images/sa-icon.png" class="rounded" alt="{{'alt.sa_logo' | translate}}">
                                    </div> 
                                    <div class="col-xs-12 col-sm-10">
                                        <div id="server_error" class="error text-center"></div>
                                        <h4>Panic Alert - 
                                            <span class="text-nowrap text-nowrap">{{cart["planName"] | translate}}</span>&nbsp;&nbsp;
                                        </h4>
                                        <div>
                                            {{cart.planDescription}}
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "roles.agents_supervisors" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ cart?.agentsSupervisors }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "roles.users" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ cart?.users }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "plan.video_feature" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ (cart?.includesVideo?'general.yes':'No') | translate }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "plan.agent_dispatch" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ (cart?.agentDispatch?'general.yes':'No') | translate }}</p>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <strong>{{ "plan.geo_zone_assignment" | translate }}:</strong>
                                            </div>
                                            <div class="col-xs-12 col-md-6">
                                                <p>{{ (cart?.geoAssignment?'general.yes':'No') | translate }}</p>
                                            </div>
                                        </div>
                                        <div class="small">
                                            {{'account.renew_details' | translate}}
                                        </div>
                                        <hr>
                                        <fieldset>
                                            <legend class="h6"><strong>{{'account.billing_cycle' | translate}}<span class="error">*</span>: </strong></legend>
                                            <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                                                <input type="radio" name="BillingCycle" formControlName="BillingCycle" value="M" (click)="getBillingQuantity('M')" [(ngModel)]="model.options">&nbsp;{{'account.monthly' | translate}}
                                            </label>
                                            <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                                                <input type="radio" name="BillingCycle" formControlName="BillingCycle" value="Y" (click)="getBillingQuantity('Y')" [(ngModel)]="model.options" >&nbsp;{{'account.yearly' | translate}}
                                            </label>
                                        </fieldset>
                                        <br>
                                        <div class="col-12 p-0" *ngIf="cardInfo!=null">
                                            <strong>{{'account.payment_information' | translate}}:</strong><br>
                                            <div class="card w-75">
                                                <div class="card-body">
                                                    <div>
                                                        <div class="row">
                                                            <div class="col-12 text-right h3"><i [class]="cardInfo['card-fa']"></i></div>
                                                            <div class="col-12 text-left">**** **** **** {{cardInfo.cardLast4Digits}}</div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-8 text-left">{{cardInfo.cardName}}</div>
                                                            <div class="col-4 text-right">{{cardInfo.cardExpirationMonth}}/{{cardInfo.cardExpirationYear}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="w-75">
                                                <strong>{{'account.billing_address' | translate}}:</strong><br>
                                                {{cardInfo.billingAddress1}}<br>
                                                {{cardInfo.billingCity}}<br>
                                                {{cardInfo.billingState}}, {{cardInfo.billingCountry}}, {{cardInfo.billingZipCode}}
                                            </div>
                                            <div class="w-75 text-right"><a class="custom-hyperlink" routerLink="payment-methods" routerLinkActive="active"><i class="fa fa-pencil"></i>{{'account.change_payment_method' | translate}}</a></div>
                                        </div>
                                        <div *ngIf="cardInfo==null">
                                            <div class="row">
                                                <div class="col-xs-12 col-sm-6">
                                                    <label class="top-bottom">{{'account.card_name' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="CardName" class="form-control" maxlength="26" 
                                                    [ngClass]="{ 'is-valid': CardName['valid'], 'is-invalid': CardName['invalid'] }"/>
                                                    <ng-container *ngIf="upgradeSubscriptionForm.get('CardName').invalid && (upgradeSubscriptionForm.get('CardName').touched || upgradeSubscriptionForm.get('CardName').dirty)">
                                                        <div *ngIf="upgradeSubscriptionForm.get('CardName').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="upgradeSubscriptionForm.get('CardName').hasError('pattern')" class="error">
                                                            {{'error.card_name' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="top-bottom">{{'account.card_number' | translate}}<span class="error">*</span></label>
                                                    <ngx-stripe-card #card [options]="cardOptions" [elementsOptions]="elementsOptions" (change)="cardUpdated($event)" (error)="error = $event"></ngx-stripe-card>
                                                    <div class="error">
                                                    {{error?.message}}
                                                    </div>
                                                    <br>
                                                </div>
                                            </div>
                                            <hr class="mt-2">
                                            <strong>{{'account.billing_address' | translate}}: </strong><br>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="top-bottom">{{'user.address' | translate}} <span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingAddress" class="form-control" 
                                                    [ngClass]="{ 'is-valid': BillingAddress['valid'], 'is-invalid': BillingAddress['invalid'] }"/>
                                                    <ng-container *ngIf="upgradeSubscriptionForm.get('BillingAddress').invalid && (upgradeSubscriptionForm.get('BillingAddress').touched || upgradeSubscriptionForm.get('BillingAddress').dirty)">
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingAddress').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingAddress').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="top-bottom">{{'user.city' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingCity" class="form-control"
                                                    [ngClass]="{ 'is-valid': BillingCity['valid'], 'is-invalid': BillingCity['invalid'] }"/>
                                                    <ng-container *ngIf="upgradeSubscriptionForm.get('BillingCity').invalid && (upgradeSubscriptionForm.get('BillingCity').touched || upgradeSubscriptionForm.get('BillingCity').dirty)">
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingCity').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingCity').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="col-6">
                                                    <label class="top-bottom">{{'user.state' | translate}}<span class="error">*</span></label>
                                                    <input type="text" formControlName="BillingState" class="form-control"
                                                    [ngClass]="{ 'is-valid': BillingState['valid'], 'is-invalid': BillingState['invalid'] }"/>
                                                    <ng-container *ngIf="upgradeSubscriptionForm.get('BillingState').invalid && (upgradeSubscriptionForm.get('BillingState').touched || upgradeSubscriptionForm.get('BillingState').dirty)">
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingState').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingState').hasError('pattern')" class="error">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <label class="top-bottom">{{'user.country' | translate}}<span class="error">*</span></label>
                                                    <input id="BillingCountry" type="text" class="form-control" maxlength="100" formControlName = "BillingCountry"
                                                    [ngClass]="{ 'is-valid': BillingCountry['valid'], 'is-invalid': BillingCountry['invalid'] }"/>
                                                    <ng-container *ngIf="upgradeSubscriptionForm.get('BillingCountry').invalid && (upgradeSubscriptionForm.get('BillingCountry').touched || upgradeSubscriptionForm.get('BillingCountry').dirty)">
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingCountry').hasError('required')" class="error">
                                                            {{'general.required_field' | translate}}
                                                        </div>
                                                        <div *ngIf="upgradeSubscriptionForm.get('BillingCountry').hasError('pattern')" class="error ta-left">
                                                            {{'error.address' | translate}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>             
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 p-2">
                        <div class="card border-top-green">
                            <div class="card-body">
                                <h4>{{'account.order_summary' | translate}}</h4>
                                <hr>
                                <h5>
                                    <div class="row">
                                        <div class="col-6">Subtotal: </div>
                                        <div class="col-6 text-right">${{subtotal?functionsService.currencyFormat(subtotal):"0"}} USD</div>
                                    </div>
                                    <div class="row d-flex" *ngIf="(cardInfo?.billingZipCode && functionsService.checkZipCode(+cardInfo.billingZipCode))">
                                        <div class="col-6">Tax (11.5%): </div>
                                        <div class="col-6 text-right">${{tax?functionsService.currencyFormat(tax):"0"}} USD</div>
                                    </div>
                                    <div id="tax-row" class="row tax-row">
                                        <div class="col-6">Tax (11.5%): </div>
                                        <div class="col-6 text-right">${{tax?functionsService.currencyFormat(tax):"0"}} USD</div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-3">Total: </div>
                                        <div class="col-9 text-right"><h3>${{total?functionsService.currencyFormat(total):"0"}} USD</h3></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <sub><i>{{'account.'+ MorY | translate}}: </i>${{(totalNP)?functionsService.currencyFormat(totalNP):" "}} USD </sub><span class="font-small"><i>{{'account.taxes_fees' | translate}}</i></span>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <input type="submit" [disabled]="((cardInfo==null)&&(!upgradeSubscriptionForm.valid||((card.getCard())&&(card.getCard()['_empty']||card.getCard()['_invalid']))))" class="btn btn-green btn-h-green w-100 ml-2 mr-2" title="{{'account.complete_order' | translate}}" 
                                            value="{{'account.complete_order' | translate}}">
                                    </div>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div *ngIf="cart==null">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 p-2">
                    <div class="card border-top">
                        <div class="card-body">
                            <h4>{{'account.account_information' | translate}}</h4>
                            <hr>
                            <div class="row">
                                <div class="col-12 profile-pic text-center">
                                    <img class="img-round" [src]="orgProfile?.logo?orgProfile.logo:'assets/images/company.png'" width="120" height="120" alt="{{orgProfile?.name}}" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <strong>{{orgProfile?.name}}</strong>
                                </div>
                            </div>
                            <div class="row pt-10">
                                <div class="col-6">
                                    <i class="fa fa-user"></i>&nbsp;<strong>{{'account.owner' | translate}}:</strong>
                                </div>
                                <div class="col-6">
                                    {{orgProfile?.profileFirstName}} {{orgProfile?.profileLastName}}
                                </div>
                            </div>
                            <div class="row pt-10">
                                <div class="col-6">
                                    <i class="fa fa-envelope"></i>&nbsp;<strong>{{'general.email' | translate}}:</strong>
                                </div>
                                <div class="col-6">
                                    {{email}}
                                </div>
                            </div>
                            <div class="row pt-10">
                                <div class="col-6">
                                    <i class="fa fa-phone"></i>&nbsp;<strong>{{'account.owner_phone' | translate}}:</strong>
                                </div>
                                <div class="col-6">
                                    {{orgProfile?.profilePhoneNumber}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2">
                    <div class="card border-top">
                        <div class="card-body">
                            <h4>{{'subscription.subscription' | translate}}</h4>
                            <hr>
                            <div class="row">
                                <div class="col-12 pl-2 font-weight-lighter h3">
                                    {{'account.invalid_subscription' | translate}} <a class="hyperlink">{{'account.here' | translate}}</a>.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
